<template>
    <tr>
        <dialog-clinic-types
            ref="clinicTypesDialog"
            v-model="res"
            :proprietary="p.proprietary"
            :type-options="typeOptions"
        />

        <td v-if="isEqual(o, n)" style="padding: 0 5px;"></td>
        <td v-else :class="{'selected': isEqual(o, res)}" style="padding: 0 5px;" valign="top">
            <a @click="cloneArrToRes(o)">
                <span class="comma">
                    <span v-for="(clinic, index) in o" :key="index">
                        {{ typeOptions.find(item => item.value === clinic).text }}
                    </span>
                </span>
                <i v-if="!o || (o.length === 0)">✕</i>
            </a>
        </td>

        <td :class="{'selected': !isEqual(o, n)}" style="padding: 0 5px;">

            <ValidationProvider  rules="required|clinicTypes" v-slot="{ errors }">
                <div class="textarea" :class="{ 'hasError': errors[0]}" v-model="res"
                     v-tooltip="{
                        content: errors[0],
                        template: errorTooltip(),
                     }"
                     @click.prevent.stop="editTypes">
                                <span class="comma">
                                    <span v-for="type in res">
                                        {{ typeOptions.find(item => item.value === type).text }}
                                    </span>
                                </span>
                    <button type="button" class="tiny">Выбрать</button>
                </div>
            </ValidationProvider>
        </td>

        <td v-if="isEqual(o, n)" style="padding: 0 5px;"></td>
        <td v-else :class="{'selected': isEqual(n, res)}" style="padding: 0 5px;" valign="top">
            <a @click="cloneArrToRes(n)">
                <span class="comma">
                    <span v-for="(clinic, index) in n" :key="index">
                        {{ typeOptions.find(item => item.value === clinic).text }}
                    </span>
                </span>
                <i v-if="!n || (n.length === 0)">✕</i>
            </a>
        </td>
    </tr>
</template>

<script>
import Base from "../Base.vue";
import DialogClinicTypes from "@dialogs/common/clinics/ClinicTypesDialog";

export default {
    mixins: [Base],
    components: {
        DialogClinicTypes,
    },
    props: {
        o: {
            type: Array,
            default: []
        },
        n: {
            type: Array,
            default: []
        },
        f: {
            type: Array,
            default: []
        },
        p: {
            type: Object,
            default: {},
        },
    },
    methods: {
        editTypes () {
            setTimeout(() => {
                this.$refs.clinicTypesDialog.$refs.dialog.show();
            }, 190);
        },
        errorTooltip () {
            return `<div class="tooltip" role="tooltip"><div class="tooltip-arrow hasError"></div><div class="tooltip-inner hasError"></div></div>`;
        },
    }
}
</script>
